
import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronRight, ArrowUp } from 'lucide-react';
import ScrollReveal from '../ui/ScrollReveal';

const FinalCTA = () => {
  const scrollToShowcase = () => {
    const showcaseSection = document.querySelector('[data-section="showcase"]');
    if (showcaseSection) {
      showcaseSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 to-black text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <ScrollReveal>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-semibold mb-6">
              Ready to Showcase Your Brand at Its Best?
            </h2>
          </ScrollReveal>
          
          <ScrollReveal delay={150}>
            <p className="text-xl text-white/80 mb-10 leading-relaxed">
              Let's create a website that not only looks incredible but drives real results for your business. 
              Book a discovery call and let's discuss your vision.
            </p>
          </ScrollReveal>
          
          <ScrollReveal delay={300}>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Button size="lg" className="bg-white text-black hover:bg-gray-100 rounded-full px-8">
                Book a Discovery Call
                <ChevronRight className="ml-2 h-4 w-4" />
              </Button>
              <Button 
                variant="outline" 
                size="lg" 
                className="border-white text-white hover:bg-white hover:text-black rounded-full px-8"
                onClick={scrollToShowcase}
              >
                See Our Work
                <ArrowUp className="ml-2 h-4 w-4" />
              </Button>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
